export const DEFAUL_GRID_COLUMNS = 12;